import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { ARTICLES_INDEX } from "@/data/articles";
import SEO, { breadcrumbJsonLd } from "@/components/SEO";

export default function Article() {
  const { slug } = useParams();
  const a = ARTICLES_INDEX[slug];

  if (!a) {
    return (
      <div className="container-x py-32 text-center">
        <h1 className="font-display text-3xl font-bold">Article not found</h1>
        <Link to="/learning" className="btn-primary mt-8 inline-flex">Learning center</Link>
      </div>
    );
  }

  const related = (a.related || []).map((s) => ARTICLES_INDEX[s]).filter(Boolean);
  const articleJsonLd = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: a.title,
    description: a.excerpt,
    articleSection: a.category,
    author: { "@type": "Organization", name: "Hurtler Environmental" },
    publisher: { "@id": "https://texas-environmental.preview.emergentagent.com/#localbusiness" },
  };

  return (
    <div data-testid="article-page">
      <SEO
        title={a.title}
        description={a.excerpt}
        path={`/learning/${a.slug}`}
        jsonLd={[
          articleJsonLd,
          breadcrumbJsonLd([
            { name: "Home", path: "/" },
            { name: "Learning Center", path: "/learning" },
            { name: a.title, path: `/learning/${a.slug}` },
          ]),
        ]}
      />
      <section className="bg-[#0F172A] text-white py-20">
        <div className="container-x max-w-4xl">
          <Link to="/learning" className="text-white/60 hover:text-white text-sm inline-flex items-center gap-2 mb-8">
            <ArrowLeft className="w-4 h-4" /> Learning center
          </Link>
          <div className="overline text-[#F59E0B] mb-4">{a.category}</div>
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight leading-tight">{a.title}</h1>
          <div className="mt-6 text-sm text-white/60">{a.readMin} min read</div>
        </div>
      </section>

      <section className="section-pad bg-white">
        <div className="container-x max-w-3xl">
          <div className="space-y-6">
            {a.body.map((p, i) => (
              <p key={`${a.slug}-p-${i}`} className="text-lg text-slate-700 leading-relaxed">{p}</p>
            ))}
          </div>

          {related.length > 0 && (
            <div className="mt-20 pt-12 border-t border-slate-100">
              <div className="overline mb-6">Related reading</div>
              <div className="grid md:grid-cols-2 gap-5">
                {related.map((r) => (
                  <Link key={r.slug} to={`/learning/${r.slug}`} data-testid={`article-related-${r.slug}`} className="card-soft p-6 block">
                    <div className="font-display font-bold text-[#0F172A]">{r.title}</div>
                    <div className="text-sm text-slate-600 mt-2 leading-relaxed">{r.excerpt}</div>
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
